import type { SVGProps } from 'react';

// ─── Custom icons ────────────────────────────────────────────────────────────
// Icons that don't exist in lucide-react, styled to match its conventions
// (24x24 viewBox, stroke-based, currentColor, standard SVG props spread onto
// the root element) so they're a drop-in replacement wherever used.

/** A channel splitting into two, like a river reaching its delta — used for "Flow" (task branching), replacing the git-branch icon with something that fits Agavi's desert/water theme instead of reading as a dev tool. */
export function FlowIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth={2}
      strokeLinecap='round'
      strokeLinejoin='round'
      {...props}
    >
      <path d='M3 12h6' />
      <path d='M9 12c2.5 0 4-3 8-4.5' />
      <path d='M9 12c2.5 0 4 3 8 4.5' />
      <path d='M17 7.5l1.8-1.3l0.6 2.1' />
      <path d='M17 16.5l1.8 1.3l0.6-2.1' />
    </svg>
  );
}
